import {
  TOPIC_DETAILS_FETCH_REQUEST,
  TOPIC_DETAILS_FETCH_SUCCESS,
  TOPIC_DETAILS_FETCH_FAILURE,
  UPDATE_TOPIC_FOLLOW_STATUS
} from "./actionTypes"

const INIT_STATE = {
  topics: {},       // topicId → { topicInfo, questionSetIds: [] }
}

const topicDetailsReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case TOPIC_DETAILS_FETCH_SUCCESS:
      console.log('action.payload:', action.payload);
      return {
        ...state,
        topics: {
          ...state.topics,
          [action.topicId]: action.payload
        }
      };

    case UPDATE_TOPIC_FOLLOW_STATUS: {
      const { topicId, isFollowing, followerCount } = action.payload;
      const topic = state.topics[topicId];

      if (!topic) return state;

      return {
        ...state,
        topics: {
          ...state.topics,
          [topicId]: {
            ...topic,
            topicInfo: {
              ...topic.topicInfo,
              isFollowing,
              followerCount,
            },
          },
        },
      };
    }

    default:
      return state;
  }
};

export default topicDetailsReducer;




